/**
 * Nombre visual de los documentos de embarque.
 *
 * El usuario puede renombrar un documento sin tocar el archivo: el nombre nuevo
 * se guarda en `displayName` y `fileName` sigue siendo el nombre real (con él
 * se arma la ruta en Storage, ver `shipmentFileStorage.ts`).
 */

/** Lo que hace falta de un documento de archivo para nombrarlo. */
export interface ShipmentFileNameRef {
  fileName: string
  displayName?: string
}

/** Nombre que se muestra: `displayName` si trae algo, si no `fileName`. */
export const getFileDisplayName = (file: ShipmentFileNameRef): string =>
  file.displayName?.trim() || file.fileName

/**
 * Nombre para descargar o adjuntar. Si el nombre visual no termina en la
 * extensión del archivo real, se la agrega: "Factura comercial" de
 * "inv_123.pdf" se descarga como "Factura comercial.pdf".
 */
export const getFileDownloadName = (file: ShipmentFileNameRef): string => {
  const name = getFileDisplayName(file)
  const dot = file.fileName.lastIndexOf('.')
  if (dot <= 0) return name
  const ext = file.fileName.slice(dot)
  return name.toLowerCase().endsWith(ext.toLowerCase()) ? name : `${name}${ext}`
}
